export default "__VITE_ASSET__CeLDjDjr__"